// Resume Template Components
export { Template1 } from './Template1';
export { Template2 } from './Template2';
export { Template3 } from './Template3';
export { Template4 } from './Template4';
export { Template5 } from './Template5';
export { Template6 } from './Template6';
export { Template7 } from './Template7';
export { Template8 } from './Template8';
export { Template9 } from './Template9';
export { Template10 } from './Template10';
export { Template11 } from './Template11';

// Template metadata for selection UI
export const templateMetadata = [
  {
    id: 'template-1',
    name: 'Professional Classic',
    description: 'Clean, ATS-friendly design with blue accents. Perfect for corporate environments.',
    component: 'Template1',
    category: 'Traditional',
    features: ['ATS Optimized', 'Corporate Friendly', 'Clean Layout']
  },
  {
    id: 'template-2',
    name: 'Modern Sidebar',
    description: 'Two-column layout with sidebar for contact info and skills. Great for tech roles.',
    component: 'Template2',
    category: 'Modern',
    features: ['Sidebar Layout', 'Space Efficient', 'Tech Focused']
  },
  {
    id: 'template-3',
    name: 'Executive Purple',
    description: 'Bold header with timeline design. Ideal for senior management positions.',
    component: 'Template3',
    category: 'Executive',
    features: ['Timeline Design', 'Executive Style', 'Bold Header']
  },
  {
    id: 'template-4',
    name: 'Elegant Green',
    description: 'Sophisticated design with emerald accents. Perfect for consulting and finance.',
    component: 'Template4',
    category: 'Professional',
    features: ['Elegant Design', 'Finance Friendly', 'Consulting Style']
  },
  {
    id: 'template-5',
    name: 'Minimalist Orange',
    description: 'Ultra-clean, minimal design with orange highlights. Great for creative roles.',
    component: 'Template5',
    category: 'Creative',
    features: ['Minimal Design', 'Creative Friendly', 'Typography Focus']
  },
  {
    id: 'template-6',
    name: 'Corporate Dark',
    description: 'Dark sidebar with skill bars. Perfect for IT and engineering roles.',
    component: 'Template6',
    category: 'Technical',
    features: ['Dark Theme', 'Skill Bars', 'Technical Focus']
  },
  {
    id: 'template-7',
    name: 'Modern Pink',
    description: 'Contemporary design with geometric elements. Great for marketing and design.',
    component: 'Template7',
    category: 'Creative',
    features: ['Geometric Design', 'Marketing Style', 'Contemporary']
  },
  {
    id: 'template-8',
    name: 'Executive Gold',
    description: 'Premium executive template with gold accents. Ideal for C-level positions.',
    component: 'Template8',
    category: 'Executive',
    features: ['Premium Design', 'C-Level Style', 'Executive Focused']
  },
  {
    id: 'template-9',
    name: 'Classic Academic',
    description: 'Traditional academic style with serif fonts. Perfect for education and research.',
    component: 'Template9',
    category: 'Academic',
    features: ['Academic Style', 'Serif Fonts', 'Traditional Layout']
  },
  {
    id: 'template-10',
    name: 'Split Modern',
    description: 'Bold split-screen design with violet accents. Great for modern tech companies.',
    component: 'Template10',
    category: 'Modern',
    features: ['Split Layout', 'Modern Design', 'Tech Startup Style']
  },
  {
    id: 'template-11',
    name: 'Professional Sidebar',
    description: 'Two-column layout with sidebar for contact and skills. Features orange accents and progress bars.',
    component: 'Template11',
    category: 'Modern',
    features: ['Two-Column Layout', 'Skill Progress Bars', 'Icon Contact Info']
  }
];

// Helper function to get template component by ID
export const getTemplateComponent = (templateId: string) => {
  const metadata = templateMetadata.find(t => t.id === templateId);
  return metadata?.component;
};

// Sample resume data for previews
export const sampleResumeData = {
  personalInfo: {
    name: "",
    title: "",
    email: "",
    phone: "",
    location: "",
    linkedin: "",
    website: ""
  },
  summary: "",
  experience: [],
  education: [],
  skills: []
};